export const applyTransactionUpdate = `temporal.transaction_enrichment_pure.applyTransactionUpdate`;
export const normalizeCategorizationForTheSameTransactions = `temporal.transaction_enrichment_normalization.normalizeCategorizationForTheSameTransactions`;
export const checkAndMergeSimilarCounterparties = `temporal.enrichment_cross_normalization.checkAndMergeSimilarCounterparties`;
